import { Component, inject, OnInit } from '@angular/core';
import { MarketplaceFacade } from '@fgb/core';

@Component({
  selector: 'fgb-marketplace-page',
  templateUrl: './marketplace-page.component.html',
  styleUrls: ['./marketplace-page.component.scss'],
})
export class MarketplacePageComponent implements OnInit {
  private marketplaceFacade = inject(MarketplaceFacade);

  ngOnInit() {
    this.marketplaceFacade.fetchMarketplaceItems();
  }
}
